import type {RouteRecordRaw} from 'vue-router';
//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const recipeRoutes: RouteRecordRaw[] = [
  {
    path: i18n.global.t('routes.recipe.recipeList'),
    name: Routes.RECIPE_LIST,
    component: () => import('@/components/recipe/RecipeList.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.recipeList'),
      active: 'recipe',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.recipeShow'),
    name: Routes.RECIPE_SHOW,
    component: () => import('@/components/recipe/RecipeShow.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.recipeShow'),
      active: 'recipe',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.recipeSearch'),
    name: Routes.RECIPE_SEARCH,
    component: () => import('@/components/recipe/RecipeSearch.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.recipeSearch'),
      active: 'recipe',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.cookbook'),
    name: Routes.COOKBOOK,
    component: () => import('@/components/recipe/cookbook/CookbookList.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.cookbook'),
      active: 'cookbook',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.cookbookShow'),
    name: Routes.COOKBOOK_SHOW,
    component: () => import('@/components/recipe/cookbook/CookbookShow.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.cookbookShow'),
      active: 'cookbook',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.create'),
    name: Routes.RECIPE_CREATE,
    component: () => import('@/components/recipe/RecipeCreate.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.create'),
      active: 'cookbook',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.recipe.edit'),
    name: Routes.RECIPE_EDIT,
    component: () => import('@/components/recipe/RecipeEdit.vue'),
    meta: {
      title: i18n.global.t('titles.recipe.edit'),
      active: 'cookbook',
      coaching: 'recipe',
      layout: 'flex',
    },
  },
];
